import { render, staticRenderFns } from "./PurchaseOrderShippingLabel.vue?vue&type=template&id=55adb452"
import script from "./PurchaseOrderShippingLabel.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderShippingLabel.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderShippingLabel.vue?vue&type=style&index=0&id=55adb452&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_lodash@4.17.21_vue-template-compiler@2.7.16_webpack@5.91.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports